module.exports = __webpack_public_path__ + "img/banner.62bc6dbe.png";